import React from 'react';

const Quote = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="M 3.17,14.113 L 10.914,6.4 L 15.986,6.412 L 8.29,14.080 L 14.69,14.080 L 14.69,25.6 L 3.17,25.6 Z M 4.45,14.623 L 4.45,24.32 L 13.41,24.32 L 13.41,15.36 L 8.29,15.36 L 5.192,15.36 L 7.387,13.173 L 12.895,7.685 L 11.44,7.681 Z M 4.45,14.623M 15.97,14.113 L 23.714,6.4 L 28.786,6.412 L 21.090,14.080 L 27.49,14.080 L 27.49,25.6 L 15.97,25.6 Z M 17.25,14.623 L 17.25,24.32 L 26.21,24.32 L 26.21,15.36 L 21.090,15.36 L 17.992,15.36 L 20.187,13.173 L 25.695,7.685 L 24.24,7.681 Z M 17.25,14.623" />
  </svg>
);

export default Quote;
